// ── Workbook globals ────────────────────────────────────────────────────────

/** `Final_Landing!Q31`. Not steel's 29e6 - see the note above. */
export const YOUNGS_MODULUS_PSI = 2_960_000;

/** `Final_Landing!I4`, the casing roughness used as a friction factor. */
export const CASING_ROUGHNESS = 0.05;

/** `Final_Traverse!I4`. The traverse uses almost no friction. */
export const TRAVERSE_CASING_ROUGHNESS = 0.00001;

/** `Final_Landing!J4`. Applies below the landing depth. */
export const EQUIPMENT_STRESS_LIMIT_PSI = 55_000;

/** `Final_Landing!K4`. Applies over the tubing joint above the landing depth. */
export const TUBING_STRESS_LIMIT_PSI = 100_000;

/** `Final_Landing!AJ`. */
export const EQUIPMENT_DLS_LIMIT_DEG_100FT = 2;

/** `Final_Landing!G4`. One joint of tubing is modelled above the equipment. */
export const TUBING_JOINT_LENGTH_FT = 30.1;

/** `Final_Landing!H4`. The wide section at the top of the tubing joint. */
export const COUPLING_LENGTH_FT = 0.5;

/** The neck at the bottom of every equipment item. Rows 9..26 hardcode `0.5`. */
export const EQUIPMENT_NECK_LENGTH_FT = 0.5;

/** `Final_Landing!B34` steps the table by 0.1 ft. */
export const STEP_SIZE_FT = 0.1;

/** `Final_Landing!C6`, added in v1.3. Pass thru ships 0.92 (v1.3 had 0.87). */
export const FLUID_SPECIFIC_GRAVITY = 0.92;

/** The `62.428` in `L4`, water at 60 degF in lb/ft3. */
export const WATER_DENSITY_LB_FT3 = 62.428;

/** The `490` in `L4`, steel in lb/ft3. */
export const STEEL_DENSITY_LB_FT3 = 490;
